





















import {Component, ModelSync, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class BoolSelect extends Vue {

  @ModelSync('value', 'change')
  readonly valueSync?: boolean

  @Prop({default: '是'})
  trueText!: string

  @Prop({default: '否'})
  falseText!: string

  @Prop({default: 'normal'})
  size!: string

  @Prop({default: false})
  clearable!: boolean
}
